import { Injectable } from '@angular/core';
import { PatientGroup } from 'src/app/data/dietitian/domain/patient_group/patient_group';

import UniqueEntityID from '../../../../../../../../core/domain/unique_entity_id';
import { DietitianId } from '../../../../../../../../data/dietitian/domain/dietitian';
import { EncouragementCommands } from '../../../../../../../../data/dietitian/domain/encouragement/encouragement_commands';
import { EncouragementTemplate } from '../../../../../../../../data/dietitian/domain/encouragement_template/encouragement-template';
import { Patient } from '../../../../../../../../data/patient/domain/patient';

@Injectable()
export class AddEncouragementModalFacade {
  constructor(private encouragementCommands: EncouragementCommands) {
    // do nothing
  }

  saveEncouragement(
    dietitianId: DietitianId,
    message: string,
    recipientName: string,
    target: Patient | Patient[] | PatientGroup,
    scheduledAt?: Date,
  ) {
    return this.encouragementCommands.saveEncouragement({
      dietitianId,
      message,
      groupId:
        target instanceof PatientGroup ? target.patientGroupId : undefined,
      patientId: Array.isArray(target)
        ? target.map((i) => i.patientId)
        : target instanceof Patient
        ? target.patientId
        : undefined,
      recipientName,
      scheduled: scheduledAt != undefined,
      scheduledAt: scheduledAt ?? new Date(),
    });
  }

  getDefaultEncouragementTemplate(): EncouragementTemplate {
    return EncouragementTemplate.create(
      {
        content: "Bonjour, comment vous sentez-vous aujourd'hui ?",
        title: 'Bonjour',
      },
      new UniqueEntityID(0),
    );
  }

  getEmptyEncouragementTemplate(): EncouragementTemplate {
    return EncouragementTemplate.create(
      {
        content: '',
        title: '',
      },
      new UniqueEntityID(-1),
    );
  }

  async saveEncouragementTemplate(template: EncouragementTemplate) {
    return await this.encouragementCommands.saveEncouragementTemplate(template);
  }

  async loadAllEncouragementTemplate(): Promise<EncouragementTemplate[]> {
    return await this.encouragementCommands.loadAllEncouragementTemplate();
  }
}
